import React, { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SwiperCore, {
  Navigation,
  Autoplay,
  FreeMode,
  Thumbs,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import * as apiUrl from "../../apiUrl";

SwiperCore.use([FreeMode, Navigation, Thumbs, Autoplay]);

function CollectionInnerFeatures({ features }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const mainSwiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

 
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const featuresSlides = features.slide_images
    ? JSON.parse(features.slide_images)
    : [];

  const featuresThumbs = features.thumb_images
    ? JSON.parse(features.thumb_images)
    : [];

  const handleNext = () => {
    if (mainSwiperRef.current && mainSwiperRef.current.swiper) {
      const newIndex = activeIndex + 1;
      mainSwiperRef.current.swiper.slideNext();
      thumbsSwiper?.slideTo(newIndex);
    }
  };

  const handlePrev = () => {
    if (mainSwiperRef.current && mainSwiperRef.current.swiper) {
      const newIndex = activeIndex - 1;
      mainSwiperRef.current.swiper.slidePrev();
      thumbsSwiper?.slideTo(newIndex);
    }
  };

  return (
    <section className="collection-inner-salient-features-sec">
      <Container fluid className="features-container">
        <Row className="flex-center">
          <Col md={5}>
            <Swiper
              loop={false}
              spaceBetween={0}
              autoplay={true}
              speed={1000}
              ref={mainSwiperRef}
              thumbs={{
                swiper:
                  thumbsSwiper && !thumbsSwiper.destroyed
                    ? thumbsSwiper
                    : null,
              }}
              onSlideChange={(swiper) => {
                setActiveIndex(swiper.activeIndex);
                setIsBeginning(swiper.isBeginning); 
                setIsEnd(swiper.isEnd);             
              }}
              modules={[Navigation, Thumbs]}
              className="mySwiper2"
            >
              {featuresSlides.map((featuresSlide, index) => (
                <SwiperSlide key={index}>
                  <div className="features-sec-img">
                    <img
                      src={`${apiUrl.apiUrl}/${featuresSlide.salient_features_slide_image}`}
                      className="img-fluid"
                      alt="Studio apartment for sale in Dubai"
                    />
                    <div className="features-sec-heading">
                      <h2 className="common-para">
                        {featuresSlide.salient_feature}
                      </h2>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>

          <Col md={7}>
            <div className="features-content-swiper-buttons">
              <button
                onClick={handlePrev}
                className="swiper-button-prev"
                disabled={isBeginning}    
              />
              <button
                onClick={handleNext}
                className="swiper-button-next"
                disabled={isEnd}        
              />
            </div>

            <div className="swiper-thumb-div">
              <Swiper
                onSwiper={setThumbsSwiper}
                loop={false}
                autoplay={true}
                speed={1000}
                spaceBetween={15}
                slidesPerView={3}
                modules={[Navigation, Thumbs]}
                className="mySwiper"
                       breakpoints={{
                  200: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                  },
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                  },
                  1280: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                  },
                  1920: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                  },
                  3840: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                  },
                }}
              >
                {featuresThumbs.map((featuresThumb, index) => (
                  <SwiperSlide key={index}>
                    <div className="features-content coll-inner-feature-content">
                      <h2 className="common-head goldenColor">
                        {features.title}
                      </h2>

                      <p
                        key={`desc-${activeIndex}`}
                        className="common-para animated-description"
                      >
                        {
                          featuresThumbs[activeIndex]
                            ?.salient_features_description
                        }
                      </p>
                    </div>

                    <img
                      src={`${apiUrl.apiUrl}/${featuresThumb.salient_features_thumb_slide_image}`}
                      className={`img-fluid thumb-image ${
                        index === activeIndex ? "active-thumb" : ""
                      }`}
                      alt="Studio apartment for sale in Dubai"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>

     
    </section>
  );
}

export default CollectionInnerFeatures;
